module.exports = "https://static.wanderu.com/static/media/booking.995c4884.png";